module.exports = __webpack_public_path__ + "img/20210812-benovelty-dbs-xero.c23d64a3.jpg";